import debounce from 'lodash/debounce'

export default {
  data: function() {
    return {
      stickyEnable: true,
      stickyMargin: 20
    }
  },

  methods: {
    handleScroll() {
      if (this.stickyEnable && this.$refs.sticky) {
        let margin = 20
        let top = window.pageYOffset || document.documentElement.scrollTop
        let translate = top - this.$refs.sticky.offsetTop + margin
        let bottom = translate + this.$refs.sticky.offsetHeight + margin

        /* Should always be on top but not below footer */
        if (
          top > this.$refs.sticky.offsetTop &&
          bottom <= this.$el.offsetHeight
        ) {
          this.setStickyTransform(`translateY(${translate}px)`)
        } else if (top < this.$refs.sticky.offsetTop) {
          this.setStickyTransform('translateY(0px)')
        } else if (bottom > this.$el.offsetHeight) {
          this.setStickyTransform(
            `translateY(${translate - (bottom - this.$el.offsetHeight)}px)`
          )
        }
      }
    },

    handleResize: debounce(function() {
      let width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth

      /**
       * Remove the sticky behavior once view changed into
       * the mobile layout
       *
       * !@TODO: Make breakout width dynamic?
       */
      if (width <= 768) {
        this.setStickyEnable(false)
      } else {
        this.setStickyEnable(true)
      }
    }, 100),

    setStickyEnable(bool) {
      this.stickyEnable = bool
      if (!this.stickyEnable) {
        this.setStickyTransform(`translateY(0px)`)
      }
    },

    setStickyTransform(transform) {
      if (this.$refs.sticky) {
        this.$refs.sticky.style.transform = transform
      }
    }
  },

  created() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)

    this.handleResize()
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  }
}
